export default "__VITE_ASSET__BFaAV$0k__"